const sportsConfig = {
    cricketOdds : ({marketId, eventId}) => {
        let url = `https://4exch.wizardnew.com/api/MatchOdds/GetOddslite/4/${marketId}/${eventId}`
        // let url = `https://4exch.wizardnew.com/api/MatchOdds/GetOddslite/4/${marketId}/${eventId}`
        return url;
    },
    cricketBookOdds : ({marketId, eventId}) => {
        // let url = `https://dream.wizardnew.com/api/MatchOdds/GetOddslite/4/${marketId}/${eventId}`
        let url = `https://4exch.wizardnew.com/api/MatchOdds/GetOddslite/4/${marketId}/${eventId}`
        return url;
    },
}
export default sportsConfig;